module.exports = __webpack_public_path__ + "img/time.3dfa287d.png";